module.exports = __webpack_public_path__ + "static/img/zhenzhong1.2d9cecd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/zhenzhong1.png
// module id = 2y4y
// module chunks = 1